import { ISidebarTab } from "../components/SidebarTab";

export const getCurrentTab = (
  key: string,
  tabs: ISidebarTab[]
): ISidebarTab => {
  const currentTab = tabs.find((tab) => tab.key === key);
  return currentTab || tabs[0];
};
